import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ECOPortalIntegrationState = {
  eco_portal: {
    exports: [],
    apiLoading: false,
    enabled: false,
  },
}

export const ECOPortalIntegrationActions = {
  fetchEcoPortalExports: async ({ commit }) => {
    commit('setEcoPortalIntegrationApiLoading', true)

    return axiosRequest.get('/admin/eco_portal/exports').
      then(({ data }) => {
        commit('setEcoPortalIntegrationExports', data || [])
      }).
      catch(handleError).
      finally(_ => commit('setEcoPortalIntegrationApiLoading', false))
  },
  checkEcoPortalEnabled: async ({ commit }) => {
    return axiosRequest.get('/admin/eco_portal/enabled').
      then(({ data }) => {
        commit('setEcoPortalEnabled', data?.enabled || false)
      }).
      catch(handleError)
  },
}

export const ECOPortalIntegrationGetters = {
  ecoPortalIntegrationApiLoading: state => state.eco_portal.apiLoading,
  ecoPortalIntegrationExports: state => state.eco_portal.exports,
  ecoPortalEnabled: state => state.eco_portal.enabled,
}

export const ECOPortalIntegrationMutations = {
  setEcoPortalIntegrationApiLoading: (state, data) => (state.eco_portal.apiLoading = data),
  setEcoPortalIntegrationExports: (state, data) => (state.eco_portal.exports = data),
  setEcoPortalEnabled: (state, data) => (state.eco_portal.enabled = data),
}
